import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-covid19policy',
  templateUrl: './covid19policy.component.html',
  styleUrls: ['./covid19policy.component.css']
})
export class Covid19policyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
